module.exports = __webpack_public_path__ + "2916ac0a3bedf7f75601f563153e452c.woff";